export { FastshiftDashboard } from './src/fastshift-dashboard';
